const dropdownRoot = document.createElement('div');
dropdownRoot.id = 'dropdown-root';
document.body.appendChild(dropdownRoot);

export { dropdownRoot };
